import * as React from 'react';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css';
import '../style/CopyrightNotice.css';

/**
 * Renders a copyright message of the form 'tenant icon © year tenant name',
 * linking to the home page of the tenant.
 *
 * Pure version of the component – only renders what you put in.
 *
 * @example
 * import {PureCopyrightNotice} from '@ta-interaktiv/react-copyright-notice';

 * class YourComponent extends React.Component {
 *   render() {
 *     return (
 *       <PureCopyrightNotice secondLevelDomainName='tagesanzeiger'
 *                            fullName='Tages-Anzeiger'
 *                            year={2017}/>
 *     )
 *   }
 * }
 *
 * @param {object} props
 * @param {boolean} [props.inverted=false] Use inverted (white-on-black) icon
 * @param {string} [props.name=Tages-Annzeiger] Tenant name
 * @param {string} [props.secondLevelDomainName=tagesanzeiger] Domain name,
 * used for
 * displaying the correct icon and linking to the home page
 * @param {number} [props.year=<current year>]
 */
export function PureCopyrightNotice(_ref) {
  var _ref$inverted = _ref.inverted,
      inverted = _ref$inverted === void 0 ? false : _ref$inverted,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'Tages-Anzeiger' : _ref$name,
      _ref$secondLevelDomai = _ref.secondLevelDomainName,
      secondLevelDomainName = _ref$secondLevelDomai === void 0 ? 'tagesanzeiger' : _ref$secondLevelDomai,
      _ref$year = _ref.year,
      year = _ref$year === void 0 ? new Date(Date.now()).getFullYear() : _ref$year;
  return React.createElement("a", {
    href: "//www.".concat(secondLevelDomainName, ".ch/"),
    className: "copyright-notice ".concat(inverted ? 'inverted' : '')
  }, ' ', React.createElement("img", {
    src: "//interaktiv.tagesanzeiger.ch/static/icons/".concat(secondLevelDomainName).concat(inverted ? '-inverted' : '', ".svg"),
    alt: "",
    className: "ui mini middle aligned right spaced image"
  }), React.createElement("small", null, "\xA9 ", year, " ", name));
}
export default PureCopyrightNotice;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-copyright-notice/es/pureCopyrightNotice.js
// module id = null
// module chunks = 